var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "form",
      attrs: { novalidate: "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
    },
    [
      _c("ValidationAlert", {
        attrs: { "error-list": _vm.errors.collect("server") },
      }),
      _vm._v(" "),
      _c(
        "fieldset",
        { staticClass: "form__group" },
        [
          _c("legend", [_vm._v("Project")]),
          _vm._v(" "),
          _c("div", { staticClass: "form__group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formData.projectName,
                  expression: "formData.projectName",
                },
                { name: "validate", rawName: "v-validate" },
              ],
              staticClass: "form__control",
              attrs: {
                id: "project",
                name: "project name",
                placeholder: "Enter a name for the project...",
                required: "",
              },
              domProps: { value: _vm.formData.projectName },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.formData, "projectName", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "form__label", attrs: { for: "project" } },
              [_vm._v("Project name")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form__validation" }, [
              _vm._v(_vm._s(_vm.errors.first("project name"))),
            ]),
          ]),
          _vm._v(" "),
          _c("FormControlUser", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'",
              },
            ],
            attrs: { name: "lead", label: "Select lead user" },
            model: {
              value: _vm.formData.lead,
              callback: function ($$v) {
                _vm.$set(_vm.formData, "lead", $$v)
              },
              expression: "formData.lead",
            },
          }),
          _vm._v(" "),
          _c("FormControlUser", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'",
              },
            ],
            attrs: { name: "team", label: "Additional users", multiple: true },
            model: {
              value: _vm.formData.team,
              callback: function ($$v) {
                _vm.$set(_vm.formData, "team", $$v)
              },
              expression: "formData.team",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "form__group form__group--submit" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "wait",
                    rawName: "v-wait:disabled",
                    value: "submit",
                    expression: '"submit"',
                    arg: "disabled",
                  },
                ],
                staticClass: "btn btn--primary",
              },
              [_vm._v("Save & Continue")]
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }